export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/account',
    meta: { },
    name: 'account',
    component: () => import(
      `@/views/app/account/account.vue`
    )
  },
  {
    path: '/attendance/personal',
    meta: { breadcrumb: true },
    name: 'attendance/personal',
    component: () => import(
      `@/views/app/attendance/personal.vue`
    )
  },
  {
    path: '/attendanceDaily',
    meta: { breadcrumb: true },
    name: 'attendanceDaily',
    component: () => import(
      `@/views/app/attendanceDaily/personalDaily.vue`
    )
  },
  {
    path: '/attendanceInstallation',
    meta: { breadcrumb: true },
    name: 'attendanceInstallation',
    component: () => import(
      `@/views/app/attendanceInstallation/monthly.vue`
    )
  },
  {
    path: '/employees',
    meta: { breadcrumb: true },
    name: 'attendanceInstallationEmployees',
    component: () => import(
      `@/views/app/attendanceInstallationEmployees/Employees.vue`
    )
  },
];
